import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license-pro';
import { XErrorBoundary, XTheme } from 'xsolis-component-library';

import 'semantic-ui-css/semantic.min.css';
import './index.css';
import 'react-table/react-table.css';

import configuration from '@/config';

import packageJson from '../package.json';
import App from './App';
import { Snackbar } from './features/Snackbar/Snackbar';
import { unregister } from './registerServiceWorker';
import { store } from './store/store';

global.appVersion = packageJson.version;

LicenseInfo.setLicenseKey(
  configuration.DATE_RANGE_PICKER_PRO_LICENSE_KEY || ''
);

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <XErrorBoundary>
        <XTheme>
          <Snackbar />
          <App />
        </XTheme>
      </XErrorBoundary>
    </Provider>
  </Router>,
  document.getElementById('root')
);

unregister();
